/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {API_PLATFORM_DENORMALIZERS as ɵb,API_PLATFORM_NORMALIZERS as ɵe,DateNormalizer as ɵc,ResourceNormalizer as ɵd,Serializer as ɵa} from './lib/serialization';